module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"location":"Location: {0}","requirement_alert":"Please, select as least 4 KPI!","apply":"Apply","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
